// extracted by mini-css-extract-plugin
export default {"section":"partnerSites-module--section--1OAuU","image":"partnerSites-module--image--k2l_V","section2":"partnerSites-module--section2--1A0cB"};